
import { Button, ButtonBase, Checkbox } from '@mui/material';
import { React, useContext, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

import Modal from 'react-bootstrap/Modal';

import CheckIcon from '@mui/icons-material/Check';
import { SnackbarContext } from '../../App';
import { useAuth } from 'react-oidc-context';

export default ({ show, onClose, clientId, initialClientName, onRefresh }) => {
  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    currentClientName,
    setCurrentClientName,
  ] = useState(initialClientName);

  useEffect(() => {
    setCurrentClientName(initialClientName);
  }, [show]);

  function changeClientName(e) {
    setCurrentClientName(e.target.value);
  }

  async function saveSelectedUsers() {
    if (currentClientName.length == 0) {
      setSnackBarMessage('Client name cannot be empty');
      setSnackBarShow(true);
      return;
    }

    try {
      const response = await fetch(`${window.origin}/api/client/${clientId}/name`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
        body: JSON.stringify({
          name: currentClientName,
        }),
      });

      if (response.status === 403) {
        setSessionExpired(true);
      } else if (!response.ok) {
        throw Error('Unexpected error occured');
      } else {
        onRefresh();
        setSnackBarMessage('Client name updated');
        setSnackBarShow(true);
      }
      onClose();
    } catch (error) {
      setSnackBarMessage('Unexpected error occured. Please try again later');
      setSnackBarShow(true);
      onClose();
    }
  }

  return (
    <Modal style={{ paddingTop: '10vh', color: 'rgb(0, 0, 0, .8)' }} dialogClassName="modal-30w" show={show} onHide={onClose}>
      <Modal.Header style={{ border: 0, color: '#ee7170', padding: 0 }}>
      </Modal.Header>
      <Modal.Body style={{ padding: '1vw', paddingTop: '2vw', textAlign: 'center' }}>
        <p style={{ fontWeight: '500', fontSize: '1vw', marginBottom: '1vw' }}>Client Name</p>
        <div><p style={{ fontSize: '0.8vw', fontWeight: '400', marginBottom: '1vw' }}>Client name must be the same as in the selected accounting software</p></div>

        <div style={{ margin: '2vw 0.5vw 0vw 0.5vw', backgroundColor: 'rgb(0, 0, 0, 0.03)', borderRadius: '1vw', overflow: 'hidden', maxHeight: '40vh', overflowY: 'scroll' }}>

          <Form.Control autoFocus style={{ height: '3vw', backgroundColor: 'rgba(0, 0, 0,.02)', border: 'none', borderRadius: '0.2vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Client Name" value={currentClientName} onChange={changeClientName} />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ border: 0, alignItems: 'center', justifyContent: 'center', borderTop: '1px solid rgb(255, 255, 255, 0.1)', margin: '0.7vw' }}>

        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Button
            onClick={() => { onClose(false); }}
            variant="outlined"
            style={{ flex: 1,
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(0, 0, 0, 0.9)', padding: '0.5vw', border: 'none', backgroundColor: 'rgb(0, 0, 0, 0.07)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%', marginRight: '0.5vw' }}
          >
            Close
          </Button>
          <Button
            onClick={saveSelectedUsers}
            variant="outlined"
            style={{ flex: 1,
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.5vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%' }}
          >
            Save
          </Button>

        </div>
      </Modal.Footer>
    </Modal>

  );
};
